// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"styles_sliderWrapper__ZHxDs"};